import { color } from '../../../../utility/constant/color.constant'
import { TTerraceColor } from '../../../../utility/type/terraceCover.type'

/**
 * Used to describe dimensions of all bars (except frontBar)
 * @param height Height in cm
 * @param width Width in cm
 * @param depth Depth in cm
 * @param color Color of the bar
 * @param angle Describes the rotation angle of the outer top bars
 */
export const bar = {
  height: 8,
  width: 8,
  depth: 8,
  color: color.anthracite as TTerraceColor,
  angle: 8,
}